import {
    OperationalMetric,
    UnitType,
    UnitTypeScheduleValue,
    UnitTypeScheduleValueUpsertInput,
    useUpsertOpMetricValuesMutation,
    useUpsertUnitTypeScheduleValuesMutation,
} from "../../../__generated__/generated_types";

export type UnitTypeScheduleValuePick<TKey extends keyof UnitTypeScheduleValue> = Pick<UnitTypeScheduleValue, TKey | "monthIndex" | "id" | "unitCount"> & {unitType: Pick<UnitType, "id" | "name">};

export type WeightFn<TKey extends keyof UnitTypeScheduleValue> = (value: UnitTypeScheduleValuePick<TKey> | UnitTypeScheduleValue) => number;
export type WeightFnV2<TKey extends keyof UnitTypeScheduleValue> = {
    fn: (value: UnitTypeScheduleValuePick<TKey> | UnitTypeScheduleValue) => number;
    fields: TKey | TKey[];
}

export type TColumnAggregator = "AVERAGE" | "WEIGHTED_AVERAGE";

export function average<TKey extends keyof UnitTypeScheduleValue>(values: UnitTypeScheduleValuePick<TKey>[], field: TKey, weightFn?: WeightFn<TKey>, columnAggregator?: TColumnAggregator): number {
    if (columnAggregator === "AVERAGE") {
        return values.map(value => parseFloat(value?.[field] ?? "0") ?? 0)?.average() ?? [];
    }
    if (columnAggregator === "WEIGHTED_AVERAGE" && weightFn) {
        const weights = values.map(value => weightFn(value));
        const sumWeights = weights.sum();
        const product = values.map(value => (parseFloat(value?.[field] ?? "0") ?? 0) * weightFn(value)).sum();
        return (product / sumWeights) ?? 0;
    }
    return 0;
}


export type HandleSaveValues = (versionId: string, values: UnitTypeScheduleValueUpsertInput[]) => Promise<void>
export function useSaveUnitTypeScheduleValues(propertyId: string, field: keyof UnitTypeScheduleValue, budgetYear: number): HandleSaveValues {
    const [upsertUnitTypeScheduleValues] = useUpsertUnitTypeScheduleValuesMutation();

    return async (versionId: string, values: UnitTypeScheduleValueUpsertInput[]): Promise<void> => {
        await upsertUnitTypeScheduleValues({
            variables: {
                propertyId,
                versionId,
                fieldName: field,
                values,
                budgetYear
            }
        });
    };
}


type HandleSaveOperationalMetric = (versionId: string, monthIndexes: number[], values: string[]) => void
export function useSaveOperationalMetric<TKey extends keyof OperationalMetric>(propertyId: string, field: TKey, budgetYear: number): HandleSaveOperationalMetric {

    const [save] = useUpsertOpMetricValuesMutation();

    return async (versionId: string, monthIndexes: number[], values: string[]) => {
        await save({
            variables: {
                propertyId,
                versionId,
                fieldName: field,
                monthIndexes,
                values,
                budgetYear
            }
        });
    };


}
